import type { FC } from "react";

import { t } from "i18n/i18n";
import { Listbox, type ListboxEntry } from "mds/components/Listbox";
import { type SquareButtonProps } from "mds/components/buttons/SquareButton";

const INDEFINITE_ID = "infinity";

type IntervalOption = { id: string; title: string; value: number };

const INTERVAL_ITEMS: Array<ListboxEntry<IntervalOption>> = [
  {
    id: INDEFINITE_ID,
    title: t("timedelta.indefinite"),
    value: Infinity,
  },
  { type: "divider" },
  ...[1, 2, 3, 4, 5, 6, 7].map((days) => ({
    id: String(days),
    title: t("timedelta.days", { count: days }),
    value: days,
  })),
];

interface LateSubmissionIntervalDropdownProps {
  value: number;
  className?: string;
  onChange: (value: number) => void;
  disabled?: boolean;
  size?: SquareButtonProps<"button">["size"];
}

export const LateSubmissionIntervalDropdown: FC<LateSubmissionIntervalDropdownProps> = ({
  value,
  onChange,
  className,
  disabled = false,
  size = "xs",
}) => {
  const selectedValue = value === Infinity ? INDEFINITE_ID : String(value);

  return (
    <Listbox
      buttonSize={size}
      className={className}
      disabled={disabled}
      items={INTERVAL_ITEMS}
      selectedValue={selectedValue}
      onSelectionChange={(item) => onChange(item.value)}
    />
  );
};
